"use strict";
var controller = function($scope, $rootScope, $http, $timeout, urls, Flash, permissions) {
  $scope.hasPermission = function(permission) {
    if (typeof $scope.permissions == 'undefined' || $scope.permissions == null) {
      return false;
    }
    var index = $scope.permissions.indexOf(permission);
    if (index > -1) {
      return true;
    }
    return false;
  };
  var initFilterDefaults = function() {
    $scope.per_page = 10;
    $scope.query = "";
    $scope.archivnr = "";
    $scope.page = 1;
  };
  var init = function() {
    $scope.urls = urls;
    $scope.count = 0;
    $scope.permissions = permissions;
    initFilterDefaults();
  }();
};
module.exports = controller;
